/*
 * *****************************************************************************
 *     Copyright (C) 2024 Motorola Solutions, Inc.
 *     All Rights Reserved.
 *     Motorola Solutions Confidential Restricted.
 * *****************************************************************************
 */

import * as JsSIP from 'jssip';
import { LocationEvent } from '../../location/model/location';
import { SortFunctions } from './sort-functions';
import { Call } from 'CalltakingCoreApi';

export class CallbackUtil {

    private static phoneRegex = new RegExp('webphone-(\\d+)\\$(\\S+)');

    public static parseUserFromSipUri(callback: string = ''): string {
        let parsed = JsSIP.URI.parse(callback);
        if (parsed) {
            if (CallbackUtil.phoneRegex.test(parsed.user)) {
                return parsed.user.match(CallbackUtil.phoneRegex)[1];
            } else if (parsed.user) {
                return parsed.user;
            } else if (parsed.host) {
                return parsed.host;  // sip:anonymous
            }
        }
        return callback;
    }

    public static isAnonymous(callback: string) {
        return Boolean(callback) && CallbackUtil.parseUserFromSipUri(callback) === 'anonymous';
    }

    public static getSortedCallLocationEvents(callId: string, redialUuid: string, latestCallId: string, locationByCallMap: { [p: string]: { [p: string]: LocationEvent } }) {
        let callLocations = locationByCallMap[callId] ? Object.values(locationByCallMap[callId]) : [];
        let latestAbandonedLocations = latestCallId && locationByCallMap[latestCallId] ? Object.values(locationByCallMap[latestCallId]) : [];
        return callLocations.length || latestAbandonedLocations.length
            ? callLocations.concat(latestAbandonedLocations).sort(SortFunctions.newestLocationEventSort)
            : locationByCallMap[redialUuid]
                ? Object.values(locationByCallMap[redialUuid]).sort(SortFunctions.newestLocationEventSort)
                : [];
    }

    public static getCallback(call: Call, username?: string) {
        return call.participants[username] ? call.participants[username].callback : call.callback;
    }
}
